<template>
    <div class="resources-selector">
        <div class="row">
            <div class="col-12">
                <FilterField @filter="handleFilter"></FilterField>
            </div>
        </div>
        <div class="row">
            <div class="col-12">

                <vue-tabs ref="tabs" v-model="selectedTab" @tab-change="handleTabChange">
                    <v-tab v-for="(type,key,index) in typesValues" :key="key" :title="getTypeLabel(key)" :style="getDisplayStyle(index)">
                        <div class="resources-list-container">
                            <div class="resources-list choices">
                                <h3 v-if="isMultiselect(type.description.type)">{{ $t('reports.lists.choices') }}<a
                                        href="#" class="none-selector"
                                        @click.stop.prevent="selectAll">{{ $t('reports.btns.allselection') }}</a></h3>
                                <ul>
                                    <li :class="{selected:isSelected(val),folder:val.children,open:val.opened,'all-selected':allSelectedInGroup(val)}"
                                        v-show="!isMultiselected(val) && isFiltered(val)"
                                        v-for="val in typesValues[key].values"
                                        @click="selectItem(val)">
                                        <span>
                                            <i v-show="val.children" class="fa fa-caret-right"></i>
                                            {{ val.name }}
                                            <span class="badge" v-show="isMultiselect(type.description.type) && val.children">{{ getCurrentChildrenCount(val) }}</span>
                                        </span>
                                        <i class="fa fa-check"></i>
                                        <a v-show="val.children && isMultiselect(type.description.type)"
                                            href="#" class="none-selector"
                                            @click.stop.prevent="selectAllInGroup(val)">
                                            {{ $t('reports.btns.allselection') }}
                                        </a>
                                        <ul :style="getItemFolderStyle(val)">
                                            <li :class="{selected:isSelected(valChild)}" v-show="!isMultiselected(valChild) && isFiltered(valChild)"
                                                v-for="valChild in val.children"
                                                @click.stop="selectItem(valChild)">
                                                <span>{{ valChild.name }}</span>
                                                <i class="fa fa-check"></i>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div class="resources-list selected" v-if="isMultiselect(type.description.type)">
                                <h3>{{ $t('reports.lists.selected') }} <span class="badge">{{ nbSelected }}</span><a
                                        href="#" class="none-selector"
                                        @click.stop.prevent="unselectAll">{{ $t('reports.btns.clearselection') }}</a>
                                </h3>
                                <ul>
                                    <li v-for="val in selectedValues" @click="unselectItem(val)">
                                        {{ val.name }}<i class="fa fa-times"></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </v-tab>
                </vue-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import find from 'lodash/find';
    import axios from 'axios';
    import API from '@/services/API.js'
    import Globals from '@/services/globals.js'
    import Utils from '@/services/utils.js'
    import Vue from 'vue'
    import {VueTabs, VTab} from 'vue-nav-tabs'
    import FilterField from '@/components/ui/Filter';

    export default {        components: {
            VueTabs,
            VTab,
            FilterField,
        },
        computed: {
            nbSelected: function () {
                return this.selectedValues.length;
            }
        },
        data () {
            return {
                typesValues: {},
                selectedValues: [],
                typeSelected: null,
                selectedTab: null,
                firstTime: true,
                currentFilter: ''
            }
        },
        methods: {
            isFiltered(item){
                if(this.currentFilter != ''){
                    if(item.children){
                        return true;
                    }
                    if(item.name.toLowerCase().indexOf(this.currentFilter.toLowerCase()) != -1){
                        return true;
                    }
                    return false;
                }
                return true;

            },
            getTypeLabel: function (key) {
                return Utils.t('reports.types.' + key);
            },
            selectItem: function (item,notifyUpdate) {

                if(!item.children) {
                    if (notifyUpdate == null) {
                        notifyUpdate = true;
                    }

                    var alreadySelected = Utils.getByIdInTree(this.selectedValues, item.id);
                    if (alreadySelected === false) {
                        if (this.typesValues[this.typeSelected].description.q == 1) {
                            this.selectedValues = [];
                            this.selectedValues[0] = item;
                        }
                        else {
                            this.selectedValues.push(item);
                        }
                        if (notifyUpdate) {
                            this.$emit('change', {type: this.typeSelected, values: this.selectedValues});
                        }


                    }
                }
                else{
                    item.opened = !item.opened;
                }

            },
            unselectItem: function (item) {
                var itemExists = Utils.getIndexByIdInArray(this.selectedValues, item.id);
                if (itemExists !== false) {
                    this.selectedValues.splice(itemExists, 1);
                    var valueToEmit = null;
                    if (this.selectedValues.length > 0) {
                        valueToEmit = this.selectedValues;
                    }
                    this.$emit('change', {type: this.typeSelected, values: valueToEmit});
                }

            },
            selectAll: function () {
                this.selectedValues = [];
                for(var sKey in this.typesValues[this.typeSelected].values){
                    if(this.typesValues[this.typeSelected].values[sKey].children){
                        for(var sKey2 in this.typesValues[this.typeSelected].values[sKey].children){
                            this.selectItem(this.typesValues[this.typeSelected].values[sKey].children[sKey2],false);
                        }
                    }
                    else{
                        this.selectItem(this.typesValues[this.typeSelected].values[sKey],false);
                    }

                }
                this.$emit('change', {type: this.typeSelected, values: this.selectedValues});
            },
            selectAllInGroup(item){
                for(var sKey2 in item.children){
                    this.selectItem(item.children[sKey2],false);
                }
                this.$emit('change', {type: this.typeSelected, values: this.selectedValues});
            },
            unselectAll: function () {
                this.selectedValues = [];
                this.$emit('change', {type: this.typeSelected, values: null});
            },
            handleTabChange(tabIndex, newTab, oldTab){
                if (newTab != oldTab) {
                    this.typeSelected = newTab.$vnode.key;
                    this.unselectAll();
                }
            },
            handleFilter(value){
                this.currentFilter = value;
                if(value != ''){
                    for(var sKey in this.typesValues[this.typeSelected].values){
                        Vue.set(this.typesValues[this.typeSelected].values[sKey],'opened',true);
                    }
                }
            },
            getCurrentChildrenCount(item){
                if(item.children){
                    var countSelected = 0;
                    var countFiltered = 0;
                    for(var sKey2 in item.children){
                        if(this.isMultiselected(item.children[sKey2])){
                            countSelected++;
                        }

                        if(this.isFiltered(item.children[sKey2])){
                            countFiltered++;
                        }
                    }
                    return countFiltered - countSelected;
                }
                return '';
            },
            isMultiselect: function (typeKey) {
                if (this.typesValues[typeKey].description.q > 1 || this.typesValues[typeKey].description.q == 'N') {
                    return true;
                }
                return false;
            },
            isSelected: function (item) {
                if (this.typesValues[this.typeSelected].description.q == 1) {
                    if (this.selectedValues[0] && item.id == this.selectedValues[0].id) {
                        return true;
                    }
                    else {
                        return false;
                    }

                }
                return false;
            },
            isMultiselected(item){
                if (this.typesValues[this.typeSelected].description.q != 1) {
                    var val = find(this.selectedValues, {id: item.id});
                    if (val) {
                        return true;
                    }
                    return false;
                }
                return false;
            },
            allSelectedInGroup(item){
                if(item.children){
                    for(var cKey in item.children){
                        if(!this.isMultiselected(item.children[cKey])){
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            },
            getDisplayStyle(index){

                return '';
            },
            getItemFolderStyle(item){
                if(item.opened === true){
                    var nbVisible = 0;
                    for(var cKey in item.children){
                        if(!this.isMultiselected(item.children[cKey]) && this.isFiltered(item.children[cKey])){
                            nbVisible++;
                        }
                    }
                    return 'height:'+(nbVisible * 39)+'px'
                }
                else{
                    return '';
                }

            },
            updateConfig: function(newValue){
                var vThis = this;


                Vue.set(this, 'typesValues', {});
                this.selectedValues = [];

                if (newValue != null) {
                    for (var tKey in newValue.type) {

                        var type = newValue.type[tKey];
                        var q = newValue.q[tKey];
                        Vue.set(this.typesValues, type, {});
                        Vue.set(this.typesValues[type], 'description', {type: type, q: q});
                        Vue.set(this.typesValues[type], 'values', []);

                        if (this.preselected) {
                            this.typeSelected = this.preselected.type;
                        }
                        else {
                            if (tKey == 0) {
                                this.typeSelected = type;
                            }
                        }


                        var url = API.endpoints.reports.resources[type] + API.constructQueryParams({perpage: 999999});

                        axios.get(url, {
                            headers: {
                                'BEEPIZ-type': type,
                            }
                        })
                            .then(function (response) {

                                if(response.config.headers['BEEPIZ-type'] == 'dati'){
                                    Vue.set(vThis.typesValues[response.config.headers['BEEPIZ-type']], 'values', response.data);
                                }
                                else{
                                    Vue.set(vThis.typesValues[response.config.headers['BEEPIZ-type']], 'values', response.data.data);
                                }

                                for (var dKey in vThis.typesValues[response.config.headers['BEEPIZ-type']].values) {
                                    var item = vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey];
                                    if(item.children != null){
                                        Vue.set(vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey],'opened',false);
                                    }
                                }

                                if (vThis.preselected && response.config.headers['BEEPIZ-type'] == vThis.preselected.type) {
                                    for (var dKey in vThis.typesValues[response.config.headers['BEEPIZ-type']].values) {
                                        if(vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey].children) {
                                            for (var dKey2 in vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey].children) {
                                                for (var sKey in vThis.preselected.values) {

                                                    if (parseInt(vThis.preselected.values[sKey]) == vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey].children[dKey2].id) {
                                                        var notifyUpdate = false;
                                                        if(sKey == vThis.preselected.values.length - 1){
                                                            notifyUpdate = true;
                                                        }
                                                        vThis.selectItem(vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey].children[dKey2],notifyUpdate);
                                                        vThis.selectedTab = vThis.getTypeLabel(response.config.headers['BEEPIZ-type']);
                                                    }
                                                }
                                            }
                                        }
                                        else{
                                            for (var sKey in vThis.preselected.values) {

                                                if (parseInt(vThis.preselected.values[sKey]) == vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey].id) {
                                                    var notifyUpdate = false;
                                                    if(sKey == vThis.preselected.values.length - 1){
                                                        notifyUpdate = true;
                                                    }
                                                    vThis.selectItem(vThis.typesValues[response.config.headers['BEEPIZ-type']].values[dKey],notifyUpdate);
                                                    vThis.selectedTab = vThis.getTypeLabel(response.config.headers['BEEPIZ-type']);
                                                }
                                            }
                                        }
                                    }
                                }

                            })
                    }


                }
            }
        },
        mounted: function () {
            if(this.config != null && this.config !== false){
                this.updateConfig(this.config);
            }
        },
        name: '',
        props: {
            config: {
                type: [Object,Boolean],
                default: function () {
                    return null;
                }
            },
            preselected: {
                type: Object,
                default: function () {
                    return null;
                }
            }
        },
        watch: {
            config: function (newValue) {
                this.updateConfig(newValue);
            },
            preselected(newValue){
                this.updateConfig(this.config);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
